import React, { useState, useEffect, Suspense } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar'
import InfiniteScroll from "react-infinite-scroller";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {Helmet} from "react-helmet";

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import './Channels.css'
import styles from '../../App.module.css'
import classes from './Channels.module.css'
import ChannelBox from '../Global/ChannelBox';
import Footer from '../Footer/Footer';
import Spinner from '../Global/Spinner';

// import noThumb from "../../images/no-thumb.jpg";

function Channels() {
  const [type, setType] = useState('mostviewed');
  const [tabIndex, setTabIndex] = useState(0);
  const [channels, setChannels] = useState([]);
  const [progress, setProgress] = useState(10);

  const [hasMore, sethasMore] = useState(true);
  const [page, setPage] = useState(2);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    window.addEventListener('scroll', function(){
      setLoading(true);
    })
  },[]);

  useEffect(() => {
    if(tabIndex === 0) {
      setType('mostviewed');
    }else if(tabIndex === 1) {
      setType('mostactive');
    }else if(tabIndex === 2) {
      setType('recentlyonline');
    }

    setPage(2);
    setChannels([]);
    setLoading(false);
  }, [tabIndex]);

  useEffect(() => {
    setProgress(50);
    axios.get(`${process.env.REACT_APP_API_URL}/api/channels.php?type=${type}&page=1&limit=15`)
    .then(response => {
      if(response.data.message !== 'No channels found') {
        setChannels(response.data);
        response.data.length < 15 ? sethasMore(false) : sethasMore(true);
      }

      setProgress(100);
      // setLoading(true);
    }).catch(err => {
      console.log(err);
    })
  }, [type]);

  const loadMore = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/api/channels.php?type=${type}&page=${page}&limit=15`)
    .then(response => {
      if(response.data.message !== 'No videos found') {
        loading && hasMore && setChannels([...channels, ...response.data]);
        setPage(page + 1);

        response.data.length < 15 ? sethasMore(false) : sethasMore(true);
      }else {
        sethasMore(false);
      }
    }).catch(err => {
      console.log(err);
    })
  }

  return (
    <>
      <Helmet>
        <title>Channels</title>
        <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
        <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar active="channels" />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <ins className='adsbygoogle p-4 pb-0'
              style={{ display: 'block' }}
              data-ad-client='ca-pub-8126596259429304'
              data-ad-slot='5153011292'
              data-ad-format='auto'
            />
            <div className={classes.channels_component + ' channels_component'}>
              <div className={classes.sec_name}>
                  <h3>Channels</h3>
              </div>
              {/* <div className="sec-tabs mb-2">
                  <ul className="d-inline">
                      <li>
                          <a href="/" className="active">Most viewed</a>
                      </li>
                      <li><a href="/">Most active</a></li>
                      <li><a href="/">Recently online</a></li>
                  </ul>
              </div> */}
              <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index) }>
                <TabList>
                    <Tab>Most viewed</Tab>
                    <Tab>Most active</Tab>
                    <Tab>Recently online</Tab>
                </TabList>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
              </Tabs>
              <div className={`${classes.channels} pb-4`}>
                {
                  channels && channels.map && <InfiniteScroll
                    pageStart={0}
                    loadMore={loadMore}
                    hasMore={hasMore}
                    loader={<div className="loader my-4" key={0} align="center">{<Spinner />}</div>}
                    className='row'
                  >
                    {
                      channels.map((channel, index) => {
                        return (
                          <div className={`${classes.channel} p-0`} key={index}>
                            {
                              ChannelBox(channel)
                            }
                          </div>
                        )
                      })
                    }
                  </InfiniteScroll>
                    
                }
              </div>
            </div>
            <Footer />
          </div>
        </Suspense>
      </div>
      </>
  )
}

export default Channels